import React, { useEffect, useState } from 'react';
import './ExploreTheConcepts.scss';
import ExploreTabs from './partials/ExploreTabs/ExploreTabs';
import Button from '../../partials/Button'
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';
import ProgressBar from '../../partials/ProgressBar/index.js';
import Instructions from '../../partials/Instructions/Instructions'


const ExploreTheConcepts = props => {

  const { data } = props || {};
  // console.log(data);

  const [source, setSource] = useState(() => {
    return {
      ...data,
      tabs: data.tabs.map(t => {
        return {
          ...t,
          cualquiercosa: true,
        }
      })
    }

  });
  const [score, setScore] = useState(0);
  const [currentTab, setCurrentTab] = useState(0);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [tabCss, setTabCss] = useState('global_button_single');
  const [modalData, setModalData] = useState({
    header: 'Header here',
    body: 'content of the modal',
    button: 'Next',
    onClose: () => { }
  });
  const [tabViewed, setTabViewed] = useState([])

  const changeScore = (points) => {
    console.log('changeScore',points);
    setScore(score + points);
  }

  const changeTab = (tab) => {
    // We set the tab visible
    let tabs = source.tabs;
    tabs[tab].visible = true;

    setSource({
      ...source,
      tabs: tabs
    });

    setCurrentTab(tab);
    let temp = tabViewed;
    temp[tab][0] = true;
    setTabViewed(temp);
    console.log(temp)
  }

  const changeSubTab = (subTab) => {
    let newData = source.tabs;
    const currentSubTab = newData[currentTab].subTabs[subTab];
    currentSubTab.active = true;
    currentSubTab.readed = true;
    newData[currentTab].subTabs.forEach((item, index) => {
      if (index !== subTab) {
        item.active = false;
      }
    });
    setSource({
      ...source,
      tabs: newData
    });
    let temp = tabViewed;
    temp[currentTab][subTab] = true;
    setTabViewed(temp)
    console.log(temp)
  }

  const retryQuiz = () => {
    setSource({
      ...source,
      tabs: data.tabs
    });
  }

  const showModal = (_data) => {
    setModalData({
      header: _data.header,
      body: _data.body,
      button: 'Close',
      onClose: () => { clearModal() },
      size: 'lg'
    });
    setModalVisibility(true);
  };

  const clearModal = () => {
    setModalVisibility(false);
    setModalData({});
  }

  useEffect(()=>{
    let arr = []
    props.data.tabs.map(x=>{
      let sub= []
      x.subTabs.map((y)=>{
        sub.push(false)
      })
      arr.push(sub)
    })
    arr[0][0] = true
    // console.log(arr)
    setTabViewed(arr);
  },[])

  // useEffect(()=>{
  //   console.log("TAB VIEW XXXXXXX",tabViewed)
  // },[tabViewed])

  return (
    <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <Instructions body={data.body} />
      <div className="back-btn-container">
        <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
      </div>
      <div className="explore-the-concepts">
        {/* <div className="explore-heading">
          <h5 dangerouslySetInnerHTML={{ __html: data.body }}></h5>
        </div> */}
        <div className="explore-body">
          <div className="tabs">
            <ExploreTabs
              data={source}
              currentTab={currentTab}
              changeTab={changeTab}
              changeSubTab={changeSubTab}
              showModal={showModal}
              clearModal={clearModal}
              modalData={modalData}
              modalVisibility={modalVisibility}
              tabCss={tabCss}
              setTabCss={setTabCss}
              changeScore={changeScore}
              score={score}
              handleComplete={props.onComplete}
              questionOptions={data.options}
              tabViewed={tabViewed}
            />
          </div>
          
        </div>
      </div>
    </InteractionContainer>
  );

};

export default ExploreTheConcepts;